// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const formatUsers = (metaData: any) => {
  return metaData.reduce((obj: any, md: any) => ({ ...obj, ...md }), {});
};
